import React from 'react';

// Loading placeholder for the scorecard card grid — mirrors `.cd-card`
// dimensions so the swap to real content doesn't shift the layout.
const ClientSkeleton = ({ count = 6 }) => (
  <div className="cd-cards" aria-busy="true">
    <span className="cd-visually-hidden">Loading your scorecard…</span>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="cd-skel-card" aria-hidden="true">
        <div style={{ display: 'flex', gap: 14 }}>
          <div className="cd-skel" style={{ width: 58, height: 58, borderRadius: '50%' }} />
          <div style={{ flex: 1 }}>
            <div className="cd-skel" style={{ width: '70%', height: 14, marginBottom: 8 }} />
            <div className="cd-skel" style={{ width: '45%', height: 12 }} />
          </div>
        </div>
        <div className="cd-skel" style={{ width: '100%', height: 40, marginTop: 18, borderRadius: 11 }} />
      </div>
    ))}
  </div>
);

export default ClientSkeleton;
